import styled, { css } from 'styled-components';
import DefaultArrowRight from '~components/svgs/ArrowRight';
import { StepStatus } from './types';

interface StepStyled {
  $variant?: StepStatus;
}

export const ArrowRight = styled(DefaultArrowRight)`
  width: ${({ theme }) => theme.spacing.km4};
`;

export const Bullet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.spacing.km8};
  height: ${({ theme }) => theme.spacing.km8};
  line-height: ${({ theme }) => theme.spacing.km8};
  border-radius: ${({ theme }) => theme.border.radius.circle};
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.default};
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-size: ${({ theme }) => theme.font.size.m3};
  flex: 0 0 ${({ theme }) => theme.spacing.km8};
`;

export const Step = styled.li<StepStyled>`
  counter-increment: listIndex;
  padding-bottom: ${({ theme }) => theme.spacing.km8};
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 1px;
    height: ${({ theme }) => theme.spacing.km8};
    position: absolute;
    left: ${({ theme }) => theme.spacing.km4};
    top: ${({ theme }) => theme.spacing.km8};
    background-color: ${({ theme }) => theme.color.background.neutral.strong};
  }

  &:last-child {
    &:before {
      display: none;
    }
  }

  ${({ $variant = 'INITIAL' }) =>
    $variant === 'CURRENT' &&
    css`
      ${Bullet} {
        border-color: ${({ theme }) => theme.color.background.success.default};
        border-width: ${({ theme }) => theme.border.width.thin};
        color: ${({ theme }) => theme.color.text.neutral.inverted};

        &::before {
          content: '';
          width: ${({ theme }) => theme.spacing.km2};
          height: ${({ theme }) => theme.spacing.km2};
          display: block;
          border-radius: 100%;
          background-color: ${({ theme }) =>
            theme.color.background.success.default};
        }
      }
    `}

  ${({ $variant = 'INITIAL' }) =>
    $variant === 'CHECKED' &&
    css`
      ${Bullet} {
        border: none;
        background-color: ${({ theme }) =>
          theme.color.background.success.default};
        color: ${({ theme }) => theme.color.text.neutral.inverted};
      }

      &::before {
        background-color: ${({ theme }) =>
          theme.color.background.success.default};
      }
    `}
`;

export const Steps = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km4};
`;
